import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import { LicenseFamily } from '../../../../Organization/Types';
import ParticipantStore from '../../../../ParticipantStore';
import ParticipantsStore from '../../../../ParticipantsStore';
import { T } from '../../../../Translations';
import Table from '../Table';

interface Props {
  participantsStore: ParticipantsStore;
  participantStores: ReadonlyArray<ParticipantStore>;
  licenseFamily: LicenseFamily;
}

function TableContent({ participantsStore, participantStores, licenseFamily }: Props) {
  return fromEmpty(participantStores)
    .map((participants) => (
      <Table
        participantsStore={participantsStore}
        participantStores={participants}
        licenseFamily={licenseFamily}
      />
    ))
    .getOrElse(() => <T kind="No Participants" />);
}

export default observer(TableContent);
